var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('populate-form',{ref:"addForm",attrs:{"formTitle":"新增自訂類型保留預約","fkey":"pra01","populateOptionVar":"addOptions","formDataObjVar":"addData"},on:{"customValueChanged":_vm.optionChanged}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }